import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import { useRecoilValue, useSetRecoilState } from "recoil";
import {
  connectSiteState,
  isEditState,
  isPrivacyAgreeState,
  naverAuthorizeUrl,
  writingTypeState
} from "../../../../atoms/atom";
import { popState } from "../../../../atoms/atom";
import {
  checkPosition,
  loginKey,
  msgRedirectURL,
  naverAuthorizePopUp
} from "../../../../utils/CommonFunc";
import {
  NAVER_SIGN_IN_URL,
  SIGN_IN_URL
} from "../../../../utils/config/Config";
import "./FloatWrite.scoped.scss";
import { isLauncherState, loginState } from "../../../../atoms/userInfoAtom";

function FloatWrite() {
  const { t } = useTranslation();
  const isLogin = useRecoilValue(loginState);
  const setPopOpen = useSetRecoilState(popState);
  const setWritingType = useSetRecoilState(writingTypeState);
  const setIsEdit = useSetRecoilState(isEditState);
  const isPrivacyAgree = useRecoilValue(isPrivacyAgreeState);
  const naverAuthorize = useRecoilValue(naverAuthorizeUrl);
  const connectSite = useRecoilValue(connectSiteState);
  const { service_code } = useParams();
  const isLauncher = useRecoilValue(isLauncherState);

  const onClickOpen = () => {
    setIsEdit(false);
    setWritingType("content");
    if (isLogin) {
      if (isPrivacyAgree) {
        setPopOpen(true);
      } else {
        checkPosition();
        naverAuthorizePopUp(naverAuthorize);
      }
    } else {
      if (isLauncher) {
        window.app.vfunRequestLogin();
      } else {
        msgRedirectURL(
          t(loginKey),
          connectSite === "vfun"
            ? SIGN_IN_URL(service_code || "vfun")
            : NAVER_SIGN_IN_URL + service_code,
          "_self"
        );
      }
    }
  };

  return (
    <div className="float-wrapper">
      <button className="write-btn" onClick={onClickOpen} />
    </div>
  );
}

export default FloatWrite;
